module.exports = __webpack_public_path__ + "static/media/api.88eeb401.svg";